<template>
  <div class="projects">
    <Library :data="data" />
    <FaPreFooter
      :title="$c.text('pages.projects.preFooterTitle')"
      :description="$c.text('pages.projects.preFooterDescription')"
      :button-title="$c.text('button.start-now')"
      columns="col-6"
      class-name="projects-pre-footer"
    />
  </div>
</template>

<script>
import Library from '@itbpbg/lms-components/src/Projects/Library';
import global from '@itbpbg/lms-components/src/mixins/global';
import FaPreFooter from '../../components/FaPreFooter';

export default {
  components: {
    Library, FaPreFooter,
  },
  mixins: [global],
  async asyncData({ $axios, route, $config }) {
    const [data, page] = await Promise.all([
      $axios.$get('/projects?page=1&initial_data=1'),
      $axios.$get(`/pages/${route.fullPath}`),
    ]);

    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return { data, page };
  },

  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
};
</script>
